import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HelperService } from "../../../../../common-items/services/helper.service";

@Component({
  selector: 'cp-token-verification-failed',
  templateUrl: './token-verification-failed.component.html',
  styleUrls: ['./token-verification-failed.component.less']
})
export class TokenVerificationFailedComponent implements OnInit {
  constructor(private router: Router , public helperService : HelperService) { }

  ngOnInit() {
  }

  proceedToLoginPage() {
    this.router.navigate(['/']);
  }

}
